import { formatDate } from 'commons/utils/date'
import { removeSpecialCharacters } from 'commons/utils/string'
import type { EdiRequest, EdiStatusOption } from 'constants/enums'

import type {
  EdiReprocessBatchPayload,
  EdiReprocessBatchPayloadApi,
  EdiRequestItemApi,
  EdiRequestListParams,
  EdiRequestListParamsApi,
  EdiRequestListResponse,
  EdiRequestListResponseApi,
  EdiStatusOptionsResponseApi,
} from './interfaces'

export const toEdiRequestListParamsApi = (
  params: EdiRequestListParams,
): EdiRequestListParamsApi => ({
  Cnpj: params.cnpj ? removeSpecialCharacters(params.cnpj) : undefined,
  CodigoSap: params.sapCode || undefined,
  DataFim: params.endDate,
  DataInicio: params.startDate,
  NumeroPedidoCliente: params.customerOrders?.length ? params.customerOrders : undefined,
  Pagina: params.page,
  RazaoSocial: params.legalName || undefined,
  Status: params.status?.length ? params.status : undefined,
  TamanhoPagina: params.perPage,
})

export const toEdiRequestItem = (item: EdiRequestItemApi): EdiRequest => ({
  customerOrder: item.NumeroPedidoCliente,
  errors: null, // NOTE: The list endpoint does not return categorized errors
  formattedDate: formatDate(item.SolicitadoEm, 'DD/MM/YYYY'),
  formattedTime: formatDate(item.SolicitadoEm, 'HH[h]mm'),
  id: item.Codigo.toString(),
  legalName: item.RazaoSocial,
  requestedAt: item.SolicitadoEm,
  sapCode: item.CodigoSap,
  status: item.Status,
})

export const toEdiRequestListResponse = (
  response: EdiRequestListResponseApi,
): EdiRequestListResponse => ({
  data: response.data ? response.data.map(toEdiRequestItem) : [],
  pagination: response.pagination,
})

export const toEdiReprocessBatchPayloadApi = (
  payload: EdiReprocessBatchPayload,
): EdiReprocessBatchPayloadApi => ({
  Codigos: payload.orderNumbers,
})

export const toEdiRequestLogs = (logs: string[]): string[] =>
  logs.map((log) => log.replace(/^"|"$/g, ''))

export const toEdiStatusOptions = (response: EdiStatusOptionsResponseApi): EdiStatusOption[] =>
  response.data.map((item) => ({ title: item.descricao, value: item.codigo }))
